/**
 * OAuth config source (013.1 AC2's deferred decision, made here).
 *
 * Placeholder/env-driven until Story 013.1 registers the real GitLab OAuth
 * Application. PKCE public client — no client secret ever belongs here.
 */
import type { ResolvedOAuth2Auth } from '@gl-demo-ultimate-odupre/connect-with-gitlab';

export const OAUTH_BASE_URL = 'https://gitlab.com';

export const oauthAuthConfig: ResolvedOAuth2Auth = {
  type: 'oauth2',
  clientId: import.meta.env.VITE_GITLAB_OAUTH_CLIENT_ID ?? '',
  redirectUri:
    import.meta.env.VITE_GITLAB_OAUTH_REDIRECT_URI ??
    `${window.location.origin}${window.location.pathname}`,
  scopes: ['read_user'],
  tokenEndpoint: `${OAUTH_BASE_URL}/oauth/token`,
};
